import classNames from 'classnames';
import React, { useMemo } from 'react';

import { generateTitleId } from '_utils/articles';

export default function ArticleTableOfContent({ titles }) {
  const [visited, setVisited] = React.useState([]);

  const titlesWithId = useMemo(
    () =>
      titles.map((title) => ({
        title,
        id: generateTitleId(title),
      })),
    [titles],
  );

  const handleClick = React.useCallback(
    (item) => {
      setVisited([...visited, item]);
      document.querySelector(`#${item.id}`)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    },
    [visited],
  );

  return (
    <div className="shadow-card text-content-primary rounded-lg my-8">
      <div className="bg-os-light-blue-25 p-4 sm:px-7 sm:py-4 text-base font-semibold">
        Table of Contents
      </div>
      <ul className="p-4 pl-8 sm:pl-11 sm:pr-7 sm:py-4 list-disc flex flex-col gap-y-2 m-0">
        {titlesWithId.map((item) => (
          <li
            key={item.id}
            className={classNames(
              'text-sm',
              visited.includes(item) && 'font-semibold',
            )}
          >
            <span
              role="link"
              tabIndex={0}
              onClick={() => handleClick(item)}
              className="text-content-primary cursor-pointer"
            >
              {item.title}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
